import React, { useState } from 'react';
import ReactTable from 'react-table'
import ReactTooltip from 'react-tooltip'
import {
    courierWithInstantPickup,
    courierWithNotes,
    normalizeCourierServices
} from "../../services/helpers/courier";
import numeral from "numeral";
import InputLocation from "../atoms/InputLocation";

const UploadOrderTable = props => {
    const columns = [{
        Header: 'NO',
        Cell: ({row,original}) => numberCell(row._index+1,original),
        maxWidth: 75,
        style: { 'whiteSpace': 'unset'},
        className:'text-center',
        headerClassName: 'text-center'
    },{
        Header: 'PENGIRIMAN',
        accessor: 'name',
        minWidth: 200,
        Cell: ({row,original})  => destinationCell(row,original),
    },{
        Header: 'BARANG',
        className:'px-3',
        accessor: 'items',
        style: { 'whiteSpace': 'unset'},
        Cell: ({row,original})  => itemCell(original),
    },{
        Header: 'KURIR',
        accessor: 'courier',
        Cell: ({row,original})  => courierCell(original),
    },{
        Header: 'HARGA',
        accessor: 'price',
        Cell: ({row,original})  => priceCell(original),
    },{
        Header: 'EDIT',
        accessor: 'delete',
        maxWidth: 75,
        Cell: ({row,original})  => actionCell(row,original),
    }];

    const numberCell = (idx,o) => {
        let priceView;
        if (o.price) {
            priceView = <b style={{'color':'#000000'}}>✅ Siap</b>
        } else if (o.error) {
            priceView =  <b style={{'color':'#000000'}}>❌ Error</b>
        } else {
            priceView =  <b style={{'color':'#000000'}}>❌ Belum Siap </b>
        }
        return (
             <div>
                <p>{idx}</p>
                 {priceView}
             </div>
        )
    };

    const destinationCell = (r,o) => {
        const idx = r._index;
        let originMapView, destinationMapView;

        if (o.originMap === 'empty') {
            originMapView = (
                <div>
                    {o.originLocation}<br/>
                    {o.error ? null :
                        <div>
                            <button onClick={() => props.onPressOriginMap(idx)}
                                    className="badge badge-danger border border-danger pointer"
                            >
                                Titik lokasi diperlukan, Klik disini.
                            </button>
                            <br/>
                        </div>
                    }
                    <i>{o.originNote === '-' ? null : o.originNote}</i>
                </div>
            )
        } else if (o.originMap === 'input') {
            originMapView = (
                <div>
                    <InputLocation
                        setLocation={(a,c,id,pc) => props.onSelectLocationOrigin(idx,a,c,pc)}
                        placeholder={'Masukkan lokasi pengirim'}
                        onLocationChange={e => props.onChangeLocationOrigin(idx,e)}
                        value={o.originInputLocation}
                        loading={false}
                    />
                </div>

            )
        } else if (o.originMap === 'filled') {
            originMapView = (
                <div>
                    {o.originLocation}<br/>
                    <i>{o.originNote === '-' ? null : o.originNote}</i>
                </div>
            )
        }

        if (o.receiverMap === 'empty') {
            destinationMapView = (
                <div>
                    {o.receiverLocation}<br/>
                    {o.error ? null :
                        <div>
                            <button onClick={() => props.onPressDestinationMap(idx)}
                                    className="badge badge-danger border border-danger pointer"
                            >
                                Titik lokasi diperlukan, Klik disini.
                            </button>
                            <br/>
                        </div>
                    }
                    <i>{o.receiverNote === '-' ? null : o.receiverNote}</i>
                </div>
            )
        } else if (o.receiverMap === 'input') {
            destinationMapView = (
                <div className="pb-5 mb-5">
                    <InputLocation
                        setLocation={(a,c,id,pc) => props.onSelectLocationDestination(idx,a,c,pc)}
                        placeholder={'Masukkan lokasi penerima'}
                        onLocationChange={e => props.onChangeLocationDestination(idx,e)}
                        value={o.receiverInputLocation}
                        loading={false}
                    />
                </div>
            )
        } else if (o.receiverMap === 'filled') {
            destinationMapView = (
                <div>
                    {o.receiverLocation}<br/>
                    <i>{o.receiverNote === '-' ? null : o.receiverNote}</i>
                </div>
            )
        }

        return (
            <div>
                <div className="pl-3">
                    <div className="row">
                        <div className="col-1 px-0">
                            <span className="text-primary">
                                <i className="fas fa-map-marker-alt mt-1"/>
                            </span>
                        </div>
                        <div className="col-11 pl-0">
                            <strong>{o.originName}</strong> <br/>
                            {o.originPhone} <br/>
                            {originMapView}
                        </div>
                    </div>
                    <div className="py-1"/>
                    <div className="row">
                        <div className="col-1 px-0">
                          <span className="text-danger">
                              <i className="fas fa-map-marker-alt mt-1"/>
                          </span>
                        </div>
                        <div className="col-11 pl-0">
                            <strong>{o.receiverName}</strong> <br/>
                            {o.receiverPhone}<br/>
                            {destinationMapView}
                        </div>
                    </div>
                </div>
            </div>
    )
    };

    const itemCell = (og) => {
        let { items } = og;
        if (courierWithNotes(og.courierCompany)) {
            return (
                <div>
                    <p>{og.orderNote}</p>
                </div>
            )
        } else {
            return (
                <div>
                    <small>LIST BARANG</small>
                    { items.map((i,idx) => (
                        <div key={idx} className="rounded p-2 mb-1 border shadow--hover">
                            <small><b>{i.quantity}x - {i.name}</b> {i.description}</small><br/>
                            <small>Rp. {numeral(i.value).format("0,0")} <br/></small>
                            <small>{i.length}x{i.width}x{i.height} cm - {i.weight} gram</small>
                        </div>
                    ))}
                </div>
            )
        }
    };

    const courierCell = (o) => {
        const { companyName,typeView } = normalizeCourierServices(o.courierCompany,o.courierType);
        let tagView;
        if (o.tags.length > 0) {
            tagView = (
                <div className="mt-3">
                    <b>Tags</b>
                    <div className="row pl-3">
                    {
                        o.tags.map(i => (
                            <div className="badge badge-info px-2 py-1 mr-1">{i}</div>
                        ))
                    }
                    </div>
                </div>
            )
        }
        if (o.error) {
            return (
                <span className="badge badge-danger">
                Layanan Tidak Terdaftar
                </span>
            )
        }
        return (
            <div>
                {companyName} - {typeView}
                {tagView}
            </div>
        )
    };

    const actionCell = (r,o) => {
        const idx = r._index;
        return (
            <div className="mb-2 pointer">
                <a onClick={() => props.onRemoveOrder(idx)}
                   className="action-item mr-2"
                   title="Trash">
                    <i className="fas fa-trash"></i>
                </a><br/>
                <small>HAPUS</small>
            </div>
        )
    }


    const priceCell = (o) => {
        if (o.loading) {
            return (
                <div>
                    <b>Menghitung Ongkir...</b>
                </div>
            )
        }
        if (o.receiverCODAmount) {
            return (
                <div>
                    <b>Rp. {numeral(o.price).format("0,0")}</b><br/>
                    <p>{o.paymentType}</p>
                    <span className="badge badge-success">
                        COD Rp {numeral(o.receiverCODAmount).format("0,0")}
                    </span>
                    <br/>
                    <b>4% Cash On Delivery Fee </b><br/>
                    <b>Rp. {numeral(4/100*o.receiverCODAmount).format("0,0")}</b><br/>
                </div>
            )
        }

        if (o.price) {
            return (
                <div>
                    <b>Rp. {numeral(o.price).format("0,0")}</b><br/>
                    <p>{o.paymentType}</p>
                </div>
            )
        } else {
            return (
                <div>
                    <p>{o.paymentType}</p>
                </div>
            )
        }
    };

    return (
        <div>
            <ReactTable
                data={props.data}
                columns={columns}
                defaultPageSize={props.data.length}
                loading={props.loading}
                showPagination={false}
                className="-striped -highlight"
            />
        </div>
    )
};

export default UploadOrderTable;
